export const WHITELIST_DETAILS_COLUMNS_WITHOUT_SPREAD = [
  'active',
  'emitter',
  'receiver',
  'monthlyRate',
  'defaultRate',
  'retentionRate',
  'commission',
  'whitelistType',
  'switchComponent',
  'editComponent',
];

export const WHITELIST_DETAILS_COLUMNS_WITH_SPREAD = [
  'active',
  'emitter',
  'receiver',
  'monthlyRate',
  'defaultRate',
  'retentionRate',
  'commission',
  'spread',
  'whitelistType',
  'switchComponent',
  'editComponent',
];
